<template>
  <header class="emi-index-header">
    <a href="/" class="emi-index-logo"></a>
    <nav class="emi-index-nav">
      <ul class="emi-index-nav-list">
        <li class="emi-index-nav-item" v-for="nav in navList" :key="nav.path" :class="{'active': ruouteName === nav.id}">
          <a class="nav-link" :href="nav.path"> {{nav.name}}</a>
          <i class="iconfont iconicondaochu-2" v-if="nav.icon"></i>
          <div class="child-nav-box" v-if="nav.child">
            <ul class="child-nav-list">
              <li class="child-nav-item" v-for="child in nav.child" :key="child.path" :class="{'active': ruouteName === child.id || subName == child.id}">
                <a :href="child.path"> {{child.name}}</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
    <div class="emi-index-account" v-if="!isLogin">
      <span class="emi-index-login">
        <a href="/index/logined"> 登录</a>
      </span>
      <span class="emi-index-register">
        <i class="iconfont iconEMI-11"></i>
        <span>
          <a href="https://account.xiaomi.com/pass/register"> 注册</a>
        </span>
      </span>
    </div>
    <div class="emi-index-account" v-else>
      <span class="emi-index-link">
        <a href="/ad"> 管理中心</a>
      </span>
      <span class="emi-index-link">
        <a href="/account/logout"> 退出</a>
      </span>
    </div>
  </header>
</template>
<script>
  import cookie from '../common/cookie.js';
  export default {
    name: 'common-header',
    data() {
      return {
        navList: [
          {name: '首页', path: '/', id: 'index'},
          {name: '资源介绍', path: '#/resource/shop', icon: true, id: 'resource', child: [
            {name: '应用商店', path: '#/resource/shop', id: 'shop'},
            {name: '信息流媒体', path: '#/resource/browser', id: 'browser'},
            {name: '小米视频', path: '#/resource/video', id: 'video'},
            {name: '手机管家', path: '#/resource/safe', id: 'safe'},
          ]},
          {name: '帮助中心', path: '/v2/dist/help.html'},
          {name: '推广合作', path: '#/core-agent', icon: true, id: 'combination', child: [
            {name: '核心代理商', path: '#/core-agent', id: 'agent'},
            {name: '营销认证', path: '#/authentication/introduce', id: 'auth'}
          ]},
          {name: '开放平台', path: '/v2/dist/api.html'},
          {name: '营销课堂', path: '/v2/dist/course.html'}
        ],
        isLogin: false
      }
    },
    computed: {
      ruouteName() {
        return this.$route.name;
      },
      subName() {
        return this.$route.params.type;
      }
    },
    created() {
      this.isLogin = !!cookie.getCookie('userId');
    }
  }
</script>